import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { useAuthRedirect } from "@/hooks/useAuthRedirect";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const NotFound = () => {
  const location = useLocation();
  const { homeRoute } = useAuthRedirect();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center bg-[#F9F9F9] p-4">
        <div className="text-center max-w-md">
          <div className="mb-6">
            <span className="text-5xl font-bold text-accent">404</span>
          </div>
          <h1 className="text-3xl font-bold mb-4">Page Not Found</h1>
          <p className="text-gray-500 mb-8">
            Oops! The sticker you&apos;re looking for seems to have been peeled off. Let&apos;s get
            you back to creating amazing stickers.
          </p>
          <Button asChild className="bg-secondary hover:bg-secondary/90">
            <Link to={homeRoute}>
              <Home className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
